import * as log from 'loglevel';
import { LogLevelDesc } from 'loglevel';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AnyAction, Store } from 'redux';

import * as CommonAuthService from '../common/services/auth/';
// import foundation from './assets/scripts/foundation.min.js';
import './assets/scripts/iframeResizer.contentWindow.js';
// import tracy from './assets/scripts/tracy.js';
import * as Base from './base/';
import { config } from './common/';
import './common/i18next-instance';
import createFontAwesomeLibrary from './FontAwesomeLibrary';


/*
    This weird syntax specifies which webpack loader that will handle these resources. This enables us to bypass css-modules.
    It's likely there is a way to express this over at webpack.config instead of here.
*/

import '!style-loader!css-loader!../../../node_modules/react-datepicker/dist/react-datepicker.css';
import '!style-loader!css-loader!../../../node_modules/react-table/react-table.css';

import '!style-loader!css-loader!../../../node_modules/slick-carousel/slick/slick-theme.css';
import '!style-loader!css-loader!../../../node_modules/slick-carousel/slick/slick.css';

import '!style-loader!css-loader!../../../node_modules/react-phone-number-input/style.css';

import '!style-loader!css-loader!../../../node_modules/react-confirm-alert/src/react-confirm-alert.css';

// import '!style-loader!css-loader!../../../node_modules/@adyen/adyen-web/dist/adyen.css';
// import '!style-loader!css-loader!../../../node_modules/foundation-sites/dist/css/foundation.css';
import '!style-loader!css-loader!../../../node_modules/react-tabs/style/react-tabs.css';

import BaseLayout from './base/components/BaseLayout';

// Prepare logging framework
log.setLevel(config.LogLevel as LogLevelDesc);

// Initialize Font Awesome (FA) library
createFontAwesomeLibrary();

export default class App extends React.Component<{}> {
    public store: Store<Base.RootState, AnyAction>;
    public alreadyLoggedIn: boolean;

    constructor(props: object) {
        super(props);
        // Prepare redux store
        const { store } = Base.Store.configureStore((window as any).__INITIAL_STATE__);
        this.store = store;
        this.alreadyLoggedIn = false;
    }

    public async componentDidMount() {
        document.title = `My${config.BrandEnv}`;  // Should render "MyBMW" or "MyMINI" on the title.

        // Handle authentication
        // TODO: refactor this to the auth module. also rethink if we should just dispatch loginUserSuccess. I think we should call Ping API to assert if the token is valid. If it is then we can dispatch loginUserSuccess, else, we clear the localStorage and remain on the login page
        // check if sessionStorage has token
        // Apr 2020: AT stored on a cookie
        // const accessToken = sessionStorage.getItem(config.AccessTokenAlias);
        const accessToken = CommonAuthService.Service.GetActualAccessToken();
        if (accessToken !== null && accessToken !== undefined) {
            this.store.dispatch(CommonAuthService.Actions.loginUserSuccess({ accessToken }));
        }

        // load external independent scripts (side-effect imports)
        // iframeResizerContentWindow; // tslint:disable-line no-unused-expression
        // foundation; // tslint:disable-line no-unused-expression
        // tracy; // tslint:disable-line no-unused-expression

        // 2023-10: Removed tracy as per BMW's request
        // const script = document.createElement('script');
        // script.src = config.ApiServerHostName + config.ScriptsPath + 'tracy.js';
        // script.async = false;
        // script.type = 'text/javascript';
        // document.body.appendChild(script);

        const scriptEpaas = document.createElement('script');
        scriptEpaas.src = config.EpaasSrc;
        scriptEpaas.setAttribute('onload', `epaas.api.initialize({tenant: '${config.EpaasTenant}', locale: '${config.EpaasLocale}'})`);
        scriptEpaas.async = false;
        scriptEpaas.type = 'text/javascript';
        document.body.appendChild(scriptEpaas);
    }

    public render() {
        return (
            <React.Suspense fallback="loading">
                <Provider store={this.store}>
                    <BrowserRouter>
                        <Base.ErrorBoundary config={config}>
                            <div id={config.BrandEnv}>
                                <BaseLayout />
                            </div>
                        </Base.ErrorBoundary>
                    </BrowserRouter>
                </Provider>
                <div id="iFrameHeight" data-iframe-height="" />
                <script src="https://cdn.jsdelivr.net/npm/foundation-sites@6.6.3/dist/js/foundation.min.js" integrity="sha256-pRF3zifJRA9jXGv++b06qwtSqX1byFQOLjqa2PTEb2o=" />
            </React.Suspense>
        );
    }
}
